import type { ConfigDeployStatusMap, DeployedConfigStatus } from '@/api/deploy';

/**
 * Builds a ConfigDeployStatusMap from a flat list of DeployedConfigStatus records.
 * The backend returns one record per environment (the latest deployed config file).
 * Groups by environment and stores as lastSuccess.
 */
export function buildConfigDeployStatusMap(
  deployments: DeployedConfigStatus[]
): ConfigDeployStatusMap {
  const map: ConfigDeployStatusMap = {};
  for (const dep of deployments) {
    const envKey = dep.environmentId;
    if (!envKey) continue;
    map[envKey] = { lastSuccess: dep };
  }
  return map;
}

/**
 * Derives the "last deployed version" string for a given environment.
 */
export function getLastDeployedVersion(
  statusMap: ConfigDeployStatusMap | undefined,
  environmentId: string
): string | undefined {
  if (!statusMap) return undefined;
  const entry = statusMap[environmentId];
  if (!entry?.lastSuccess) return undefined;
  return entry.lastSuccess.version ?? undefined;
}

/**
 * Formats a last deployed version for display.
 * Returns the version string or a placeholder when absent.
 */
export function formatLastDeployedVersion(version: string | undefined): string {
  if (!version) return '—';
  return version;
}
